/**
 * This composable sets the page title for the current Storyblok page. It uses an API route to fetch the title,
 * so that the server-side API route can handle the multiple required API calls to Storyblok and cache the result.
 *
 * This composable currently supports the Storyblok Content Types listed in the `PageStory` type in the
 * `app/server/api/page-title/[...slug].get.ts` file.
 */
export const usePageTitle = () => {
    const runtimeConfig = useRuntimeConfig();
    const { lang, country } = useLanguage();
    const { rawPath } = useCleanStoryblokPath();

    const headers = useRequestHeaders(['cookie']);
    const { data } = useFetch<string>(
        // Use '__home' as a placeholder when rawPath is empty (homepage), because
        // the [...slug] catch-all route requires at least one path segment.
        () => `/api/page-title/${rawPath.value || '__home'}?country=${country.value}&language=${lang.value}`,
        {
            headers
        }
    );

    useSeoMeta({
        title: () => {
            return data.value || runtimeConfig.public.defaultTitleSuffix;
        }
    });
};
